import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import { PropType, ref } from "vue";
import { Mail } from "@/types";
import api from "@/api";
import { useUiStore } from "@/stores/ui";
import InnLoadingScreen from "@/components/ds/loading-screen/LoadingScreen.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'MailSend',
  props: {
    mail: {
        type: Object as PropType<Mail>,
        required: true,
    },
},
  setup(__props) {

const props = __props;

const uiStore = useUiStore();

const loading = ref(false);

const send = () => {
    loading.value = true;
    api.mail(props.mail.id)
        .then((mail: Mail) => {
            props.mail.sent = mail.sent;
            uiStore.message("Mail verstuurd...");
        })
        .finally(() => {
            loading.value = false;
        });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      onClick: _cache[0] || (_cache[0] = ($event: any) => (send())),
      class: "MailSend"
    }, "Verzenden"),
    (loading.value)
      ? (_openBlock(), _createBlock(InnLoadingScreen, { key: 0 }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})